'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type SecondaryButtonProps = {
  text: string;
  actionHandler: () => void;
};

export const SecondaryButton = ({ text, actionHandler }: SecondaryButtonProps) => (
  <Button
    variant="link"
    className="w-full px-1 lg:w-auto"
    aria-label={text}
    onClick={actionHandler}
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault(); // To prevent scrolling, when card is clicked.
        actionHandler();
      }
    }}
  >
    <span className="text-size-body1">{text}</span>
  </Button>
);
